import './style.css'
import Joyride, { ACTIONS, STATUS, EVENTS } from 'react-joyride'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react';
import CustomTooltip from './CustomTooltip';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { MODAL_TOGGLE, WALKTHROUGH_END, WALKTHROUGH_TOOLBAR_CLOSE, WALKTHROUGH_TOOLBAR_OPEN } from '../../redux/actions/app';
import { ID as CREATE_NODE } from '../CreateNode/config';
import { NODE_ADD } from '../../redux/actions/board';
import { createWalkthroughNode } from '../../util/board';

const Walkthrough = () => {

    const dispatch = useDispatch(),
    labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    running = useSelector( state => state.app.walkthrough.running ),
    steps = useMemo( () => [
        {
            content: labels.walkthroughStep,
            disableBeacon: true,
            target: 'body',
            placement: 'center',
            title: labels.walkthroughTitle
        },
        {
            content: labels.toolbarStep,
            disableBeacon: true,
            placement: 'left',
            target: '.coe__toolbar > button',
            title: labels.toolbarTitle
        },
        {
            content: labels.toolbarStepHelp,
            disableBeacon: true,
            placement: 'left',
            target: '.coe__toolbar_startWalkthrough',
            title: labels.toolbarTitle
        },
        {
            content: labels.toolbarStepZoom,
            disableBeacon: true,
            placement: 'left',
            target: '.coe__toolbar__zoomOut',
            styles: {
                spotlight: {
                    paddingBottom: '60px'
                }
            },
            title: labels.toolbarTitle
        },
        {
            content: labels.toolbarStepAddNode,
            disableBeacon: true,
            placement: 'left',
            target: '.coe__toolbar__add',
            title: labels.toolbarTitle
        },
        {
            content: labels.createNodeStep,
            disableBeacon: true,
            placement: 'center',
            target: 'body',
            title: labels.createNodeTitle
        },
        {
            content: labels.createNodeStepNodeType,
            disableBeacon: true,
            placement: 'right',
            target: '.coe__selectNodeType',
            title: labels.createNodeTitle
        },
        {
            content: labels.createNodeStepNodeName,
            disableBeacon: true,
            placement: 'right',
            target: '.coe__nodeName',
            title: labels.createNodeTitle
        },
        {
            content: labels.createNodeStepNodeAdd,
            disableBeacon: true,
            placement: 'auto',
            target: '.coe__createNode__add',
            title: labels.createNodeTitle
        },
        {
            content: labels.editingNodesStep,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__node__container',
            title: labels.editingNodesTitle
        },
        {
            content: labels.editingNodesStepDetails,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__node__options',
            title: labels.editingNodesTitle
        },
        {
            content: labels.namingBoardStep,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__boardName',
            title: labels.namingBoardTitle
        },

        {
            content: labels.lastStepsStepSave,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__masthead .MuiButtonBase-root:first-child',
            title: labels.lastStepsTitle
        },
        {
            content: labels.lastStepsStepMint,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__masthead .MuiButtonBase-root:last-child',
            title: labels.lastStepsTitle
        },
        {
            content: labels.lastStepsStepOffers,
            disableBeacon: true,
            placement: 'bottom',
            target: '.coe__masthead .MuiButtonBase-root:first-child',
            title: labels.lastStepsTitle
        },
        {
            content: labels.doneStep,
            disableBeacon: true,
            placement: 'center',
            target: 'body',
            title: labels.doneTitle
        },
        
    ],  [ labels ]);

    /**
     * @name callback
     * @function
     * @description Handles event changes with the walkthrough
     * @param {object} data 
     */
    const callback = ({ action, index, status, type }) => {

        // user quit the walkthrough
        if( [ STATUS.FINISHED, STATUS.SKIPPED ].includes( status ) ){
            dispatch({ type: WALKTHROUGH_END });

        // other stuff
        } else {

            // user advancing the toolbar step, so we need to open it
            if( index === 1 && action === ACTIONS.NEXT && type === EVENTS.STEP_AFTER ){
                dispatch({ type: WALKTHROUGH_TOOLBAR_OPEN });

            // open the "add node" modal
            } else if( index === 4 && action === ACTIONS.NEXT && type === EVENTS.STEP_AFTER ){
                dispatch({ type: MODAL_TOGGLE, payload: CREATE_NODE  });
                dispatch({ type: WALKTHROUGH_TOOLBAR_CLOSE });

            // add the example node to the board before the modal closes
            } else if( index === 7 && action === ACTIONS.NEXT && type === EVENTS.STEP_AFTER ){
                dispatch({ type: NODE_ADD, payload: { node: createWalkthroughNode() } });

            // dismiss the "add node modal" 
            } else if( index === 8 && action === ACTIONS.NEXT && type === EVENTS.STEP_AFTER ){                
                dispatch({ type: MODAL_TOGGLE });
                
            }
        }

        

    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <Joyride 
            autoStart
            callback={ callback }
            continuous
            run={ running }
            steps={ steps }
            tooltipComponent={ CustomTooltip } />
    )

}

export default Walkthrough